module.exports = __webpack_public_path__ + "img/join_banner.f604047.f604047a.png";